(function () {
"use strict";
var $197cd56b15c33885$var$gameField = document.querySelector(".game-field");
var $197cd56b15c33885$var$scoreField = document.querySelector(".game-score");
var $197cd56b15c33885$var$startMessage = document.querySelector(".message-start");
var $197cd56b15c33885$var$loseMessage = document.querySelector(".message-lose");
var $197cd56b15c33885$var$winMessage = document.querySelector(".message-win");
var $197cd56b15c33885$var$button = document.querySelector(".button");
var $197cd56b15c33885$var$initialState = Array.from({
    length: $197cd56b15c33885$var$gameField.tBodies[0].rows.length
}, function() {
    return Array($197cd56b15c33885$var$gameField.tBodies[0].rows[0].cells.length).fill(0);
});
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $ac6739cbe5bf1c84$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}


function $f86983e96b0c893e$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $ea91727f98d0802f$export$71511d61b312f219(obj, privateSet) {
    (0, $f86983e96b0c893e$export$71511d61b312f219)(obj, privateSet);
    privateSet.add(obj);
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$_addCell = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_getEmptyCells = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_getRandomEmptyCell = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_transpose = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_moveCellsInGroup = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_setStatus = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_checkWin = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_checkCanMove = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_canMoveInGroup = /*#__PURE__*/ new WeakSet();
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ], gameBoard = arguments.length > 1 ? arguments[1] : void 0, scoreField = arguments.length > 2 ? arguments[2] : void 0;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_addCell);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_getEmptyCells);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_getRandomEmptyCell);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_transpose);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_moveCellsInGroup);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_setStatus);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_checkWin);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_checkCanMove);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_canMoveInGroup);
        this.initialState = initialState;
        this.state = initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
        this.status = Game.STATUSES.idle;
        this.score = 0;
        this.gameBoard = gameBoard;
        this.scoreField = scoreField;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = Game.STATUSES.playing;
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_addCell, $3d28d7f1aac198f5$var$addCell).call(this);
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_addCell, $3d28d7f1aac198f5$var$addCell).call(this);
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.state = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.status = Game.STATUSES.idle;
                this.score = 0;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this;
                if (this.status !== Game.STATUSES.playing) return;
                var canMoveLeftInGroup = false;
                this.state = this.state.map(function(row) {
                    if (!(0, $ac6739cbe5bf1c84$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_canMoveInGroup, $3d28d7f1aac198f5$var$canMoveInGroup).call(_this, row)) return row;
                    canMoveLeftInGroup = true;
                    return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_moveCellsInGroup, $3d28d7f1aac198f5$var$moveCellsInGroup).call(_this, row);
                });
                if (canMoveLeftInGroup) (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_addCell, $3d28d7f1aac198f5$var$addCell).call(this);
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_setStatus, $3d28d7f1aac198f5$var$setStatus).call(this);
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this;
                if (this.status !== Game.STATUSES.playing) return;
                var canMoveRightInGroup = false;
                this.state = this.state.map(function(row) {
                    var rowReversed = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                    if (!(0, $ac6739cbe5bf1c84$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_canMoveInGroup, $3d28d7f1aac198f5$var$canMoveInGroup).call(_this, rowReversed)) return row;
                    canMoveRightInGroup = true;
                    return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_moveCellsInGroup, $3d28d7f1aac198f5$var$moveCellsInGroup).call(_this, rowReversed).reverse();
                });
                if (canMoveRightInGroup) (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_addCell, $3d28d7f1aac198f5$var$addCell).call(this);
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_setStatus, $3d28d7f1aac198f5$var$setStatus).call(this);
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this;
                if (this.status !== Game.STATUSES.playing) return;
                var canMoveUpInGroup = false;
                var cellsGroupByColumns = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_transpose, $3d28d7f1aac198f5$var$transpose).call(this, this.state);
                var updatedCellsGroupByColumns = cellsGroupByColumns.map(function(row) {
                    if (!(0, $ac6739cbe5bf1c84$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_canMoveInGroup, $3d28d7f1aac198f5$var$canMoveInGroup).call(_this, row)) return row;
                    canMoveUpInGroup = true;
                    return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_moveCellsInGroup, $3d28d7f1aac198f5$var$moveCellsInGroup).call(_this, row);
                });
                this.state = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_transpose, $3d28d7f1aac198f5$var$transpose).call(this, updatedCellsGroupByColumns);
                if (canMoveUpInGroup) (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_addCell, $3d28d7f1aac198f5$var$addCell).call(this);
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_setStatus, $3d28d7f1aac198f5$var$setStatus).call(this);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this;
                if (this.status !== Game.STATUSES.playing) return;
                var canMoveDownInGroup = false;
                var cellsGroupByColumns = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_transpose, $3d28d7f1aac198f5$var$transpose).call(this, this.state);
                var updatedCellsGroupByColumns = cellsGroupByColumns.map(function(row) {
                    var reversedRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                    if (!(0, $ac6739cbe5bf1c84$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_canMoveInGroup, $3d28d7f1aac198f5$var$canMoveInGroup).call(_this, reversedRow)) return row;
                    canMoveDownInGroup = true;
                    return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_moveCellsInGroup, $3d28d7f1aac198f5$var$moveCellsInGroup).call(_this, reversedRow).reverse();
                });
                this.state = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_transpose, $3d28d7f1aac198f5$var$transpose).call(this, updatedCellsGroupByColumns);
                if (canMoveDownInGroup) (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_addCell, $3d28d7f1aac198f5$var$addCell).call(this);
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_setStatus, $3d28d7f1aac198f5$var$setStatus).call(this);
            }
        },
        {
            key: "updateGameBoard",
            value: function updateGameBoard() {
                var regex = /field-cell--\d+/;
                var currState = this.getState();
                this.scoreField.innerText = this.getScore();
                for(var i = 0; i < currState.length; i++)for(var j = 0; j < currState.length; j++){
                    if (currState[i][j] !== 0) {
                        this.gameBoard.rows[i].cells[j].className = "field-cell field-cell--".concat(currState[i][j]);
                        this.gameBoard.rows[i].cells[j].innerText = currState[i][j];
                    } else if (currState[i][j] === 0 && regex.test(this.gameBoard.rows[i].cells[j].className)) {
                        this.gameBoard.rows[i].cells[j].className = "field-cell";
                        this.gameBoard.rows[i].cells[j].innerText = "";
                    }
                }
            }
        }
    ]);
    return Game;
}();
(0, $cd5a47cf8ef6d766$export$71511d61b312f219)($3d28d7f1aac198f5$var$Game, "STATUSES", {
    idle: "idle",
    playing: "playing",
    win: "win",
    lose: "lose"
});
function $3d28d7f1aac198f5$var$addCell() {
    var coord = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_getRandomEmptyCell, $3d28d7f1aac198f5$var$getRandomEmptyCell).call(this);
    if (coord !== null) this.state[coord[0]][coord[1]] = Math.random() < 0.9 ? 2 : 4;
}
function $3d28d7f1aac198f5$var$getEmptyCells() {
    var emptyCells = [];
    for(var i = 0; i < this.state.length; i++){
        for(var j = 0; j < this.state[0].length; j++)if (this.state[i][j] === 0) emptyCells.push([
            i,
            j
        ]);
    }
    return emptyCells;
}
function $3d28d7f1aac198f5$var$getRandomEmptyCell() {
    var emptyCells = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_getEmptyCells, $3d28d7f1aac198f5$var$getEmptyCells).call(this);
    if (emptyCells.length < 1) return null;
    var randomIndex = Math.floor(Math.random() * emptyCells.length);
    return emptyCells[randomIndex];
}
function $3d28d7f1aac198f5$var$transpose(arr) {
    return arr[0].map(function(_, colIndex) {
        return arr.map(function(row) {
            return row[colIndex];
        });
    });
}
function $3d28d7f1aac198f5$var$moveCellsInGroup(group) {
    var mergedValues = [
        0,
        0,
        0,
        0
    ];
    for(var i = 1; i < group.length; i++){
        if (group[i] === 0) continue;
        var cellWithNumIndex = i;
        var targetCellIndex = null;
        var j = i - 1;
        while(j >= 0 && (group[j] === 0 || group[j] === group[cellWithNumIndex] && mergedValues[j] !== 1)){
            targetCellIndex = j;
            j--;
        }
        if (targetCellIndex === null) continue;
        if (group[targetCellIndex] === 0) {
            group[targetCellIndex] = group[cellWithNumIndex];
            group[cellWithNumIndex] = 0;
        } else {
            group[targetCellIndex] += group[cellWithNumIndex];
            group[cellWithNumIndex] = 0;
            mergedValues[targetCellIndex] = 1;
            this.score += group[targetCellIndex];
        }
    }
    return group;
}
function $3d28d7f1aac198f5$var$setStatus() {
    if (!(0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_checkCanMove, $3d28d7f1aac198f5$var$checkCanMove).call(this)) this.status = $3d28d7f1aac198f5$var$Game.STATUSES.lose;
    if ((0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_checkWin, $3d28d7f1aac198f5$var$checkWin).call(this)) this.status = $3d28d7f1aac198f5$var$Game.STATUSES.win;
}
function $3d28d7f1aac198f5$var$checkWin() {
    return this.state.some(function(row) {
        return row.some(function(cell) {
            return cell === 2048;
        });
    });
}
function $3d28d7f1aac198f5$var$checkCanMove() {
    var _this = this;
    var emptyCells = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_getEmptyCells, $3d28d7f1aac198f5$var$getEmptyCells).call(this);
    if (emptyCells.length >= 1) return true;
    var canMoveHorisontal = this.state.some(function(row) {
        var reversedRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        if ((0, $ac6739cbe5bf1c84$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_canMoveInGroup, $3d28d7f1aac198f5$var$canMoveInGroup).call(_this, row) || (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_canMoveInGroup, $3d28d7f1aac198f5$var$canMoveInGroup).call(_this, reversedRow)) return true;
        return false;
    });
    var canMoveVertical = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_transpose, $3d28d7f1aac198f5$var$transpose).call(this, this.state).some(function(row) {
        var reversedRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        if ((0, $ac6739cbe5bf1c84$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_canMoveInGroup, $3d28d7f1aac198f5$var$canMoveInGroup).call(_this, row) || (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_canMoveInGroup, $3d28d7f1aac198f5$var$canMoveInGroup).call(_this, reversedRow)) return true;
        return false;
    });
    return canMoveHorisontal || canMoveVertical;
}
function $3d28d7f1aac198f5$var$canMoveInGroup(group) {
    return group.some(function(cell, index) {
        if (index === 0) return false;
        if (cell === 0) return false;
        if (group[index - 1] === 0) return true;
        if (group[index] === group[index - 1]) return true;
        return false;
    });
}
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports($197cd56b15c33885$var$initialState, $197cd56b15c33885$var$gameField.tBodies[0], $197cd56b15c33885$var$scoreField);
$197cd56b15c33885$var$button.addEventListener("click", function() {
    if ($197cd56b15c33885$var$button.classList.contains("start")) {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$button.classList.remove("start");
        $197cd56b15c33885$var$button.classList.add("restart");
        $197cd56b15c33885$var$button.innerText = "Restart";
        $197cd56b15c33885$var$startMessage.classList.add("hidden");
    } else if ($197cd56b15c33885$var$button.classList.contains("restart")) {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$button.classList.remove("restart");
        $197cd56b15c33885$var$button.classList.add("start");
        $197cd56b15c33885$var$button.innerText = "Start";
        $197cd56b15c33885$var$startMessage.classList.remove("hidden");
        $197cd56b15c33885$var$winMessage.classList.add("hidden");
        $197cd56b15c33885$var$loseMessage.classList.add("hidden");
    }
    $197cd56b15c33885$var$game.updateGameBoard();
});
$197cd56b15c33885$var$setupInputOnce();
function $197cd56b15c33885$var$setupInputOnce() {
    window.addEventListener("keydown", $197cd56b15c33885$var$handleInput, {
        once: true
    });
    $197cd56b15c33885$var$setupTouchControls();
}
function $197cd56b15c33885$var$handleInput(e) {
    switch(e.key){
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        default:
            $197cd56b15c33885$var$setupInputOnce();
            return;
    }
    $197cd56b15c33885$var$updateGame();
}
function $197cd56b15c33885$var$setupTouchControls() {
    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var touchEndY = 0;
    var threshold = 50;
    window.addEventListener("touchstart", function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
    }, {
        once: true
    });
    window.addEventListener("touchend", function(e) {
        touchEndX = e.changedTouches[0].clientX;
        touchEndY = e.changedTouches[0].clientY;
        handleSwipe();
    }, {
        once: true
    });
    function handleSwipe() {
        var deltaX = touchEndX - touchStartX;
        var deltaY = touchEndY - touchStartY;
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            if (deltaX > threshold) $197cd56b15c33885$var$game.moveRight();
            else if (deltaX < -threshold) $197cd56b15c33885$var$game.moveLeft();
        } else {
            if (deltaY > threshold) $197cd56b15c33885$var$game.moveDown();
            else if (deltaY < -threshold) $197cd56b15c33885$var$game.moveUp();
        }
        $197cd56b15c33885$var$updateGame();
    }
}
function $197cd56b15c33885$var$updateGame() {
    $197cd56b15c33885$var$game.updateGameBoard();
    var resultStatus = $197cd56b15c33885$var$game.getStatus();
    if (resultStatus === $3d28d7f1aac198f5$exports.STATUSES.win) $197cd56b15c33885$var$winMessage.classList.remove("hidden");
    if (resultStatus === $3d28d7f1aac198f5$exports.STATUSES.lose) $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
    $197cd56b15c33885$var$setupInputOnce();
}

})();
//# sourceMappingURL=index.f7e3b843.js.map
